import en from './en';
import symbols from './symbols';

export interface IKeyMeta {
  span: number;
  character?: string;
  icon?: string;
  special?: string;
  keyboard?: string;
}

export interface IKeyboardRow {
  keys: Array<IKeyMeta>;
}

const searchLayouts = {
  en,
  symbols,
};

export default searchLayouts;
